import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useStyles } from "./classes";
import styles from "./ViewRestaurant.module.css";
import PhoneIcon from "@material-ui/icons/Phone";
// import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";
// import BookIcon from "@material-ui/icons/Book";
// import * as moment from "moment/moment";
import formatOpeningHours from "../../utils/formatOpeningHours";
import GoogleMap from "../../utils/GoogleMaps";
import * as api from "../../api/index.js";
import Feedback from "../../components/feedback/Feedback";
import { Fragment } from "react";

export default function RestaurantDetails({ id, name }) {
  const classes = useStyles();

  const [details, setDetails] = useState({});
  const [openingHours, setOpeningHours] = useState([]);

  const user = JSON.parse(localStorage.getItem("profile"));

  const get = async () => {
    try {
      const data = await api.restaurant(id);

      const formatData = formatOpeningHours(data.data.openingHours);
      setDetails(data.data);
      setOpeningHours(formatData);
    } catch (error) {
      //setAlert
      console.log("error", error);
    }
  };

  const favoriteRemove = async (id) => {
    try {
       await api.removeFavd({
        type: "restaurant",
        id: id,
      });
      await get();

    } catch (error) {
      console.log(error);
    }
  };

  const favoriteAdd = async (id) => {
    try {
      await api.addToFavd({
        type: "restaurant",
        id: id,
      });
      await get();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    get();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <Card className={classes.restaurantD}>
        <CardContent>
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            //justify="center"
            alignItems="center"
          >
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              justify="center"
              alignItems="center"
            >
              <img src={details.logo} className={classes.logo} alt="logo"></img>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} container>
              <Typography className={classes.description}>
                {details.description}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} justify="center">
              <Paper variant="outlined" className={styles.map} id="googleMap">
                {details.location && details.location.coordinates && (
                  <GoogleMap location={details.location} />
                )}
              </Paper>
              {/**Map */}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography display="block" className={classes.description} style={{marginTop:'1.5rem'}}>
                {details.address}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              container
              //justify="flex-start"
            >
              <Typography variant="h6" className={classes.hrsTxt}>
                {" "}
                <Box fontWeight="fontWeightBold">Opening Hours</Box>
              </Typography>
            </Grid>

            <Grid container item xs={12} sm={12} md={12} lg={12}>
              <Grid item xs={12} sm={6} md={6} lg={12}>
                {openingHours.map((open) => {
                  return (
                    <Grid
                      container
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      style={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                      <Typography className={classes.description} align="left">
                        {`${open.day} :`}
                      </Typography>

                      <Typography
                        className={classes.description}
                        align="left"
                        style={{ marginLeft: "5px" }}
                      >
                        {`${open.from} - ${open.to}`}
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={12}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  container
                  justify="flex-start"
                  className={classes.phone}
                >
                  <Button
                    startIcon={<PhoneIcon />}
                    className={classes.phoneBtn}
                    disableRipple
                  >
                    {" "}
                    {details.phoneNumbers}
                  </Button>
                </Grid>

                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  justify="space-between"
                  alignItems="center"
                >
                  {user ? (
                    <Fragment>
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        {details.isFavorite ? (
                          <Button
                            startIcon={<FavoriteIcon />}
                            className={classes.linkButton}
                            disableRipple
                            onClick={() => favoriteRemove(id)}
                          >
                            favourite
                          </Button>
                        ) : (
                          <Button
                            startIcon={<FavoriteBorderIcon />}
                            className={classes.linkButton}
                            disableRipple
                            onClick={() => favoriteAdd(id)}
                          >
                            favourite
                          </Button>
                        )}
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Feedback name={name} id={id} />
                      </Grid>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        {details.isFavorite ? (
                          <Button
                            startIcon={<FavoriteIcon />}
                            className={classes.linkButton}
                            disableRipple
                            onClick={() => favoriteRemove(id)}
                          >
                            favourite
                          </Button>
                        ) : (
                          <Button
                            startIcon={<FavoriteBorderIcon />}
                            className={classes.linkButton}
                            disableRipple
                            onClick={() => favoriteAdd(id)}
                          >
                            favourite
                          </Button>
                        )}
                      </Grid>
                    </Fragment>
                  )}
                </Grid>

                {/* <Grid xs={12} sm={12} md={12} lg={12}>
                  <Button className={classes.dwnButton}>
                    <Box display="inline">
                      <GetAppIcon />
                    </Box>
                    <Box display="inline"> Download Menu </Box>
                  </Button>
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}
